const spacing = {
  empty: '0',
  default: '1rem',
  xxs: '0.25rem',
  xs: '0.5rem',
  s: '0.75rem',
  m: '1rem',
  l: '1.5rem',
  xl: '2rem',
  xxl: '3rem',
  xxxl: '6rem',
  xxxxl: '7.5rem',
  insetDefault: '1rem 1rem 1rem 1rem',
  insetXxs: '0.25rem 0.25rem 0.25rem 0.25rem',
  insetXs: '0.5rem 0.5rem 0.5rem 0.5rem',
  insetS: '0.75rem 0.75rem 0.75rem 0.75rem',
  insetM: '1rem 1rem 1rem 1rem',
  insetL: '1.5rem 1.5rem 1.5rem 1.5rem',
  insetXl: '2rem 2rem 2rem 2rem',
} as const

export type ThemeSpacing = typeof spacing

export default spacing
